import { useRef, useEffect, useState } from "react";
import {
    IcApkWebBtn,
    IcTFWebBtn,
    IcApkMobileBottomBtn,
    IcApkMobileMainBtn,
    IcTFMobileBottomBtn,
    IcDownAppStoreMobile,
    IcDownAppStoreWhite,
    IcDownGoogleStoreMobile,
    IcDownGoogleStoreWhite,
    IcDownAppStore2,
    // LastPageTitle,
} from "../../constants/icons";
import Qrcode from "../Qrcode/Qrcode";
import "./lastpage.css";
import LastPageTitle from "../../assets/images/g1cash-last-title.png";
import { alertComming, downloadApk, onClickAppDownLink } from "../../utility/utility";

const LastPage = () => {
    const lastPageRef = useRef(null);
    const [show, setShow] = useState(false);

    useEffect(() => {
        //for interaction
        const observer = new IntersectionObserver(
            (entries) => {
                entries.map((entry) => {
                    if (entry.isIntersecting && !entry.target.classList.contains("show")) {
                        setShow(true);
                    }
                });
            },
            { threshold: 0.5 }
        );
        observer.observe(lastPageRef.current);
    }, []);

    return (
        <div className={`${show ? "show" : ""} last-page`} ref={lastPageRef}>
            {/* <LastPageTitle className="last-page-title" /> */}
            <img src={LastPageTitle} className="last-page-title" />
            <div className="last-body-qr">
                <div>
                    {/* <IcApkWebBtn onClick={downloadApk} /> */}
                    <IcDownGoogleStoreWhite /> 
                    <Qrcode type="googlestore" />
                </div>
                <div>
                    {/* <IcTFWebBtn onClick={alertComming} /> */}
                    <IcDownAppStoreWhite />
                    {/* <div className="qr">
                        <IcDownAppStore2 onClick={alertComming} />
                    </div> */}
                    <Qrcode type="appstore" />
                    
                </div>
            </div>
            {/* <span className="info-message web">* apk를 다운받은 사용자는 삭제 후 다시 다운받아주세요.</span> */}

            <div className="last-body-btn">
                {/* <IcApkMobileBottomBtn onClick={downloadApk} /> */}
                {/* <IcTFMobileBottomBtn onClick={alertComming} /> */}
                <IcDownGoogleStoreMobile onClick={() => onClickAppDownLink("googlestore")} />
                <IcDownAppStoreMobile onClick={() => onClickAppDownLink("appstore")} />
                {/* <IcDownAppStoreMobile onClick={alertComming} /> */}
            </div>
            {/* <span className="info-message mobile">* apk를 다운받은 사용자는 삭제 후 다시 다운받아주세요.</span> */}
        </div>
    );
};

export default LastPage;
